import { render, staticRenderFns } from "./CommercialProductAddAlternativeModal.vue?vue&type=template&id=45a9f766&lang=html&"
import script from "./CommercialProductAddAlternativeModal.vue?vue&type=script&lang=js&"
export * from "./CommercialProductAddAlternativeModal.vue?vue&type=script&lang=js&"
import style0 from "./CommercialProductAddAlternativeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports